import type { ReactNode } from 'react'

/**
 * Title row + live ticker — every variant uses the same scaffolding.
 * The `controls` slot is where the variant slots in its toggle (or
 * leaves empty for flat-list variants).
 */
const Header = ({ controls }: { controls?: ReactNode }) => (
  <div className="px-4 pt-3 pb-2 flex items-center justify-between gap-3">
    <h1 className="font-display text-xl font-bold text-green-900">
      Leaderboard
    </h1>
    {controls ?? null}
  </div>
)

export default Header
